import { Button } from 'react-bootstrap';

import './SingTimePopup.scss';

const CancelRecordPopup = ({ onCancelRecording, onContinueRecording }) => {
  return (
    <div className='sing-time-popup'>
      <h1>
        Are you sure to stop recording? <br /> You will lose your record at this
        point.
      </h1>
      <Button variant='danger' onClick={onCancelRecording}>
        Yes
      </Button>
      <Button variant='success' onClick={onContinueRecording}>
        No
      </Button>
    </div>
  );
};

export default CancelRecordPopup;
